import type { PromptBlueprint } from "@/types";

export const GEMINI_SYSTEM_ONLY_WARNING =
  "Gemini may reject prompts containing only system instructions. Add a non-empty user message or supported media before running.";

export const getGeminiPromptWarning = (blueprint: PromptBlueprint): string | null => {
  const model = blueprint.metadata?.model;
  const template = blueprint.prompt_template;
  const isGemini =
    model &&
    ["google", "vertexai"].includes(model.provider) &&
    [model.name, model.base_model].some(name => name?.toLowerCase().includes("gemini"));

  if (
    !isGemini ||
    !("messages" in template) ||
    template.messages.length === 0 ||
    !template.messages.every(message => ["system", "developer"].includes(message.role))
  ) {
    return null;
  }

  return GEMINI_SYSTEM_ONLY_WARNING;
};
